<template>
    <v-form @submit.prevent="$emit('submit')" :disabled="disabled">
        <v-row class="px-6 py-4">
            <v-col cols="12">
                <v-img class="mx-auto" contain width="300" height="160" :src="logoEmpresa"></v-img>
            </v-col>
            <v-col cols="12">
                <v-alert class="text-left" type="success" v-model="alertExito" dismissible>
                    <p class="my-0" v-text="msjRespuesta"></p>
                </v-alert>
                <v-alert class="text-left" type="error" v-model="alertError" dismissible>
                    <p v-text="msjRespuesta" class="my-0"></p>
                    <ul class="my-0" v-for="(errors, index) in listErrors" :key="index">
                        <li v-text="errors[0]"></li>
                    </ul>
                </v-alert>
            </v-col>
            <v-col cols="12">
                <v-text-field
                    :value="usuario"
                    @input="$emit('update:usuario', $event)"
                    label="Usuario"
                    prepend-icon="mdi-account-lock"
                    type="text"
                    maxlength="50"
                />
            </v-col>
            <v-col cols="12">
                <v-text-field
                    :value="clave"
                    @input="$emit('update:clave', $event)"
                    label="Contraseña"
                    prepend-icon="mdi-lock-question"
                    :append-icon="mostrarClave ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="mostrarClave ? 'text' : 'password'"
                    @click:append="mostrarClave = !mostrarClave"
                    maxlength="24"
                />
            </v-col>
            <v-col cols="12" class="text-center">
                <v-btn :loading="disabled" type="submit" color="success">
                    <v-icon left="">mdi-login</v-icon>
                    Ingresar
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
    export default {
        name: 'LoginForm',
        props: {
            logoEmpresa: {
                type: String,
                default: '',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            alertExito: {
                type: Boolean,
                default: false,
            },
            alertError: {
                type: Boolean,
                default: false,
            },
            msjRespuesta: {
                type: String,
                default: '',
            },
            listErrors: {
                type: Array,
                default: () => [],
            },
            usuario: {
                type: String,
                default: '',
            },
            clave: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                mostrarClave: false,
            };
        },
    };
</script>

<style scoped></style>
